import { Component } from '@angular/core';

@Component({
  template:`
    <p>You need web3 to continue</p>
  `
})
export class needWeb3Component {
}



// WEBPACK FOOTER //
// ./src/app/needWeb3/needWeb3.component.ts